import type { AnalyticsEventName, AnalyticsProperties } from "../config/analytics-events";

declare global {
  interface Window { dataLayer?: Array<Record<string, unknown>> }
}

const allowedProperties = new Set([
  "assessment_session_id", "question_id", "selected_answer_ids", "intent", "step_number", "viewport_category", "referrer_domain",
]);

export function safeAnalyticsProperties(properties: Record<string, unknown>): AnalyticsProperties {
  return Object.fromEntries(Object.entries(properties).filter(([key]) => allowedProperties.has(key))) as AnalyticsProperties;
}

export function trackEvent(event: AnalyticsEventName, properties: AnalyticsProperties = {}): void {
  try {
    const payload = { event, ...safeAnalyticsProperties(properties) };
    if (typeof window !== "undefined" && Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    if (import.meta.env.DEV) console.info("[analytics]", payload);
  } catch {
    // Analytics must never interrupt the assessment or submission journey.
  }
}

export function viewportCategory(width = window.innerWidth): "mobile" | "tablet" | "desktop" {
  if (width < 768) return "mobile";
  if (width < 1024) return "tablet";
  return "desktop";
}
